import { BankingSessionIsActiveService } from 'types/services';
import { m8API } from '../m8';

export const bankingSessionIsActive: BankingSessionIsActiveService = async (
  name
) => {
  if (name === 'PRIOR') {
    return m8API.admin.priorbankStatus();
  }

  if (name === 'NBRB') {
    const status = await m8API.admin.nbrbServiceStatus();

    return !!status;
  }

  throw new Error(`Unknown banking session name: ${name}`);
};
